/**
 * Composes a room's display name the same way the backend does
 * (`ProjectTagDisplayName.Get`): the room name, plus a trimmed, parenthesized
 * label note when one is present.
 *
 * This MUST stay in sync with the backend implementation — unit-template
 * import matching relies on the composed string being byte-for-byte equal to
 * what the backend produces for `ProjectTagType.NewRoom` tags.
 */
export function getRoomDisplayName(name: string, labelNote?: string | null): string {
    const trimmedNote = labelNote?.trim();
    return trimmedNote ? `${name} (${trimmedNote})` : name;
}
